import React from 'react';
import { Icon } from './Icon';

export const Spinner = ({className, style, size = 'lg'}) => {
  return (
    <Icon i={'spinner'}  className={`${className}`} style={{filter: 'contrast(175%) brightness(10%)' ,...style}} size={size} />
  )
}
